import React, { useRef, useState, useEffect } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import globalStyles from "../../global";
import CardComponent from "./CardComponent";

const events = [
  {
    title: "Meet the Founder of Asia's largest laundry chain in Doha",
    date: "11th February 2024",
    time: "10:00AM – 05:00PM",
    location: "JW Marriott, Doha",
    description:
      "Benefit from our solid online and offline presence, boasting the enviable Google rating of 4.5/5. We’re the only .",
    image: "dohaImage.png",
    joinedCount: 20,
    regButton: true,
    buttonUrl: "/register/doha",
  },
  {
    title: "Meet the Founder of Asia's largest laundry chain in Abu Dhabi",
    date: "13th February 2024",
    time: "10:00AM – 05:00PM",
    location: "Le Royal Meridian, Abu Dhabi",
    description:
      "Benefit from our solid online and offline presence, boasting the enviable Google rating of 4.5/5. We’re the only .",
    image: "dohaImage.png",
    joinedCount: 20,
    regButton: true,
    buttonUrl: "/register/abudhabi",
  },
  {
    title: "Meet the Founder of Asia's largest laundry chain in Srilanka",
    date: "13th February 2024",
    time: "10:00AM – 05:00PM",
    location: "Le Royal Meridian, Abu Dhabi",
    description:
      "Benefit from our solid online and offline presence, boasting the enviable Google rating of 4.5/5. We’re the only .",
    image: "dohaImage.png",
    joinedCount: 20,
    regButton: true,
    buttonUrl: "/register/abudhabi",
  },
   {
    title: "Meet the Founder of Asia's largest laundry chain in Dubai",
    date: "13th February 2024",
    time: "10:00AM – 05:00PM",
    location: "Le Royal Meridian, Abu Dhabi",
    description:
      "Benefit from our solid online and offline presence, boasting the enviable Google rating of 4.5/5. We’re the only .",
    image: "dohaImage.png",
    joinedCount: 20,
    regButton: true,
    buttonUrl: "/register/abudhabi",
  },
   {
    title: "Meet the Founder of Asia's largest laundry chain in Ghana",
    date: "13th February 2024",
    time: "10:00AM – 05:00PM",
    location: "Le Royal Meridian, Abu Dhabi",
    description:
      "Benefit from our solid online and offline presence, boasting the enviable Google rating of 4.5/5. We’re the only .",
    image: "dohaImage.png",
    joinedCount: 20,
    regButton: true,
    buttonUrl: "/register/abudhabi",
  }
];

const CARD_GAP = 24;

function getVisibleCards() {
  if (typeof window === "undefined") return 1;
  const width = window.innerWidth;
  if (width >= 1200) return 2;
  if (width >= 600) return 2;
  return 1;
}

const UpcomingEventsSection = () => {
  const [visibleCards, setVisibleCards] = useState(getVisibleCards());
  const [currentSlide, setCurrentSlide] = useState(0); // index of the first card of the current slide
  const sliderRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setVisibleCards(getVisibleCards());
      setCurrentSlide(0);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const maxSlide = events.length - visibleCards;

  const handlePrev = () => {
    setCurrentSlide((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setCurrentSlide((prev) => Math.min(prev + 1, maxSlide));
  };

  // Calculate translateX for sliding effect
  const getTranslateX = () => {
    if (!sliderRef.current) return 0;
    const cardWidth = sliderRef.current.offsetWidth / visibleCards;
    return -(currentSlide * (cardWidth + CARD_GAP));
  };

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        background: globalStyles.colors.base_light,
        py: { xs: 4, md: 8 },
        px: { xs: 1, md: 4 }
      }}
    >
      <Box sx={{ mx: "auto", textAlign: "center" }}>
        <Typography
          variant="h1_gothic"
          sx={{
          
            fontSize: { xs: "24px", sm: "38px", md: "40px" } ,
           
          }}
        >
          UPCOMING EVENTS
        </Typography>
        <Typography variant="body2"
          sx={{
          
            fontSize: { xs: "12px", sm: "18px", md: "18px" },
        
          }}
        >
          Learn from the best about setting up & scaling a laundry business.
        </Typography>
        {/* Slider Controls */}
        <Box sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          mb: 2
        }}>
          <IconButton
            sx={{
              background: "#fff",
              boxShadow: "0 1px 6px 0 rgba(0,0,0,0.07)",
              "&:hover": { background: globalStyles.colors.uclean_works },
              width: 40,
              height: 40
            }}
            onClick={handlePrev}
            disabled={currentSlide === 0}
          >
            <ArrowBackIosIcon sx={{ color: globalStyles.colors.army_green }} />
          </IconButton>
          <Box
            ref={sliderRef}
            sx={{
              display: "flex",
              gap: `${CARD_GAP}px`,
              width: "100%",
              maxWidth: 1300,
              overflow: "hidden",
              justifyContent: "center",
              position: "relative"
            }}
          >
            <Box
              sx={{
                display: "flex",
                transition: "transform 0.5s cubic-bezier(0.4,0,0.2,1)",
                transform: {
                  xs: `translateX(-${currentSlide * 100}%)`,
                  // We'll use a px value below for smoothness (see getTranslateX)
                },
                ...(sliderRef.current && {
                  transform: `translateX(${getTranslateX()}px)`
                })
              }}
            >
              {events.map((event, idx) => (
                <Box
                  key={idx}
                  className="event-card"
                  sx={{
                    flex: `0 0 calc(${100 / visibleCards}% - ${CARD_GAP}px)`,
                    maxWidth: `calc(${100 / visibleCards}% - ${CARD_GAP}px)`,
                    minWidth: 260,
                  }}
                >
                  <CardComponent {...event} />
                </Box>
              ))}
            </Box>
          </Box>
          <IconButton
            sx={{
              background: "#fff",
              boxShadow: "0 1px 6px 0 rgba(0,0,0,0.07)",
              "&:hover": { background: globalStyles.colors.uclean_works },
              width: 40,
              height: 40
            }}
            onClick={handleNext}
            disabled={currentSlide >= maxSlide}
          >
            <ArrowForwardIosIcon sx={{ color: globalStyles.colors.army_green }} />
          </IconButton>
        </Box>
        <Button
          variant="outlined"
          sx={{
            borderRadius: "8px",
            mt: 4,
            color: globalStyles.colors.army_green,
            borderColor: globalStyles.colors.army_green,
            fontFamily: globalStyles.fonts.primary,
            fontWeight: 600,
            fontSize: "16px",
            px: 5,
            py: 1.2,
            textTransform: "none",
            "&:hover": {
              background: globalStyles.colors.army_green,
              color: "#fff",
              borderColor: globalStyles.colors.army_green,
            },
          }}
          href="/events"
        >
          View All Events
        </Button>  
      </Box>
    </Box>
  );
};

export default UpcomingEventsSection;